/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantMasterDataListResponse } from '../../models/tenant-master-data-list-response';

export interface GetTenantMasterData$Params {

/**
 * tenant shortcode
 */
  tenant_short_code: string;
}

export function getTenantMasterData(http: HttpClient, rootUrl: string, params: GetTenantMasterData$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantMasterDataListResponse>> {
  const rb = new RequestBuilder(rootUrl, getTenantMasterData.PATH, 'get');
  if (params) {
    rb.path('tenant_short_code', params.tenant_short_code, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantMasterDataListResponse>;
    })
  );
}

getTenantMasterData.PATH = '/api/v1/tenants/{tenant_short_code}/masterdata';
